import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import TrustStrip from "@/components/home/TrustStrip";
import BrandCards from "@/components/BrandCards";
import PartnersMarquee from "@/components/PartnersMarquee";
import CompanySection from "@/components/CompanySection";
import CatalogSection from "@/components/CatalogSection";
import PromoSlot from "@/components/home/PromoSlot";
import ServiceStrip from "@/components/home/ServiceStrip";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import BackToTop from "@/components/BackToTop";
import LoadingScreen from "@/components/LoadingScreen";
import { SEOHead, homepageJsonLd } from "@/components/seo/SEOHead";

const Index = () => {
  return (
    <>
      <SEOHead
        path="/"
        jsonLd={homepageJsonLd()}
      />
      <LoadingScreen />
      <Header />
      <main>
        {/* Zone 1: Presentation */}
        <HeroSection />
        <TrustStrip />
        <BrandCards />
        <PartnersMarquee />
        <CompanySection />

        {/* Gold divider */}
        <div className="h-1 w-full" style={{ background: "var(--gold-gradient)" }} />

        {/* Zone 2: Shopping */}
        <CatalogSection />
        <PromoSlot />
        <ServiceStrip />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
      <BackToTop />
    </>
  );
};

export default Index;
